import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, vShow as _vShow, withCtx as _withCtx, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "py-4 px-6"
};
const _hoisted_2 = {
  class: "p-4 flex"
};
const _hoisted_3 = {
  class: "pl-2 text-base font-medium"
};
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
export default {
  __name: 'IntegrationRequiredModal',
  props: {
    title: {
      type: String,
      required: true
    },
    body: {
      type: String,
      required: true
    },
    showSupportLink: {
      type: Boolean,
      default: false
    },
    supportText: {
      type: String,
      required: false
    },
    goAndSetupText: {
      type: String,
      required: false
    },
    secondaryAction: {
      type: String,
      required: false,
      default: null
    },
    showGoAndSetup: {
      type: Boolean,
      default: false
    }
  },
  emits: ["cancel", "openSupportLink", "goToSetup", "secondaryAction"],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emits = __emit;
    return (_ctx, _cache) => {
      const _component_v_spacer = _resolveComponent("v-spacer");
      const _component_v_card_actions = _resolveComponent("v-card-actions");
      const _component_v_card = _resolveComponent("v-card");
      return _openBlock(), _createBlock(_component_v_card, {
        title: __props.title
      }, {
        append: _withCtx(() => [_createVNode(LlSecondaryButton, {
          icon: "mdi-close",
          variant: "text",
          density: "compact",
          "aria-label": "Close",
          onClick: _cache[0] || (_cache[0] = $event => _ctx.$emit('cancel'))
        })]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[5] || (_cache[5] = _createElementVNode("div", {
          class: "text-center warning pt-1"
        }, [_createElementVNode("i", {
          class: "fa fa-warning"
        })], -1)), _createElementVNode("div", _hoisted_3, _toDisplayString(__props.body), 1)]), _createVNode(_component_v_card_actions, {
          class: "tw"
        }, {
          default: _withCtx(() => [_createVNode(_component_v_spacer), _withDirectives(_createVNode(LlSecondaryButton, {
            color: "primary",
            onClick: _cache[1] || (_cache[1] = $event => _ctx.$emit('goToSupportLink'))
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(__props.supportText), 1)]),
            _: 1
          }, 512), [[_vShow, __props.showSupportLink]]), _withDirectives(_createVNode(LlSecondaryButton, {
            color: "primary",
            onClick: _cache[2] || (_cache[2] = $event => _ctx.$emit('goToSetup'))
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(__props.goAndSetupText), 1)]),
            _: 1
          }, 512), [[_vShow, __props.showGoAndSetup]]), __props.secondaryAction ? (_openBlock(), _createBlock(LlSecondaryButton, {
            key: 0,
            id: "btn-sent-with-payment-link",
            "data-cy": "btn-sent-with-payment-link",
            onClick: _cache[3] || (_cache[3] = $event => _ctx.$emit('secondaryAction'))
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(__props.secondaryAction), 1)]),
            _: 1
          })) : _createCommentVNode("", true), _createVNode(LlSecondaryButton, {
            onClick: _cache[4] || (_cache[4] = $event => _ctx.$emit('cancel'))
          }, {
            default: _withCtx(() => [...(_cache[6] || (_cache[6] = [_createTextVNode("Cancel", -1)]))]),
            _: 1
          })]),
          _: 1
        })])]),
        _: 1
      }, 8, ["title"]);
    };
  }
};